import { User } from "lucide-react"

import { cn } from "@/lib/utils"

export type VoiceGender = "male" | "female" | null

export function VoiceGenderIcon({
  labels,
  className,
}: {
  labels?: Record<string, string>
  className?: string
}) {
  const gender = getVoiceGender(labels)

  switch (gender) {
    case "female":
      return (
        <span aria-label="Female voice">
          <svg
            aria-hidden="true"
            viewBox="0 0 24 24"
            className={cn("h-4 w-4", className)}
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="8" r="5" />
            <path d="M12 13v8M8.5 17.5h7" />
          </svg>
        </span>
      )
    case "male":
      return (
        <span aria-label="Male voice">
          <svg
            aria-hidden="true"
            viewBox="0 0 24 24"
            className={cn("h-4 w-4", className)}
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="9" cy="15" r="5" />
            <path d="m13 11 7-7M15 4h5v5" />
          </svg>
        </span>
      )
    case null:
      return (
        <User
          aria-label="Voice"
          className={cn("h-3 w-3", className)}
        />
      )
    default: {
      const exhaustiveGender: never = gender
      return exhaustiveGender
    }
  }
}

export function getVoiceGender(
  labels?: Record<string, string>,
): VoiceGender {
  const gender = labels?.gender?.toLowerCase()
  if (gender === "male" || gender === "female") return gender
  return null
}
